import { useEffect, useState } from "react";

const WHITELISTED_DOMAIN = `${process.env.ACCESS_DAPP_WHITELISTED_DOMAIN}`;

export const AvererContainer = (props) => {
  // const openSupportLink = () => {
  //   window.open(
  //     "https://averer-help.freshdesk.com/support/tickets/new",
  //     "_blank",
  //     "noopener,noreferrer"
  //   );
  // };

  const [isWhitelisted, setIsWhitelisted] = useState(false);

  useEffect(() => {
    try {
      const parentOrigin = new URL(document.referrer).origin;
      if (WHITELISTED_DOMAIN && parentOrigin === WHITELISTED_DOMAIN) {
        setIsWhitelisted(true);
      }
    } catch (error) {
      console.warn("Unable to verify iframe parent origin:", error);
    }
  }, []);

  return (
    <div className="averer-container">
      {isWhitelisted && (
        <div className="averer-header">
          <div>
            <img src="/averer-logo.svg" alt="Averer-logo" />
            <h2>
              Identity verification<span>_</span>
            </h2>
          </div>
          {/* TODO : Uncomment this code when need contact support button */}
          {/* <button onClick={openSupportLink} className="support-button">
          Contact Support
        </button> */}
        </div>
      )}
      {props.children}
    </div>
  );
};
